import { Classification, DepartmentCode } from 'types';
import { generateQueryString } from '../strings/shared-helpers-strings';
import { externalDeliveryfileListDetailService } from '@services/private/external-delivery/file-list-detail.service';
import { is200xRange } from '@utils/utilities';
import { updateState } from '../update-state';

type ListDataType = {
  page: number;
  size: number;

  sortName: 'lfsKind' | 'deptCd' | 'originName' | '';
  sortType: string | null;
  schLfsKind: '' | 'allow' | 'deny';
  schDeptCd: DepartmentCode | '';
  schGroup: 'subject' | 'filename' | 'subject_filename' | '';
  schKeyword: string;
  adminConfigEnv: {
    cssJsVersion: string;
  } | null;
  shmList:
    | [
        {
          shmSeq: string;
          shmLfsKind: Classification;
          shmDeptCd: DepartmentCode;
          fileCount: number;
          shmSubject: string;
          shmfOriginName: string;
          shmfSize: number;
          regDt: string;
        },
      ]
    | [];
  totalCount: number;
};

export const getExternalDeliveryFileList = async (
  listData: ListDataType,
  payload = [],
  stateSetter,
  fields,
) => {
  const {
    page,
    size,
    sortName,
    sortType,
    schLfsKind,
    schDeptCd,
    schGroup,
    schKeyword,
  } = listData;

  const queryString = generateQueryString(
    [
      { key: 'page', value: page },
      { key: 'size', value: size },
      { key: 'sortName', value: sortName },
      { key: 'sortType', value: sortType },
      { key: 'schLfsKind', value: schLfsKind },
      { key: 'schDeptCd', value: schDeptCd },
      { key: 'schGroup', value: schGroup },
      { key: 'schKeyword', value: schKeyword },
    ].map((item) => {
      return fields.includes(item.key)
        ? payload.find((field) => {
            // @ts-ignore
            return field.key === item.key;
          })
        : item;
    }),
  );

  const { response, statusCode } =
    await externalDeliveryfileListDetailService(queryString);

  if (response?.code === '1' && is200xRange(statusCode)) {
    const list = [
      { key: 'adminConfigEnv', value: response?.result?.adminConfigEnv },
      { key: 'shmList', value: response?.result?.shmListInfo?.shmList },
      { key: 'totalCount', value: response?.result?.shmListInfo?.totalCount },
    ];

    payload.forEach((item) => {
      list.push(item);
    });

    updateState(list, stateSetter);
  }
};
